import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import './index.css'
import { setupInterceptors } from './api/interceptors/interceptor'
import enterToNext from './directives/enterToNext'

const app = createApp(App)
const pinia = createPinia()

pinia.use(piniaPluginPersistedState)

app.use(pinia)
app.use(router)
app.directive('enter-to-next', enterToNext)
app.mount('#app')

setupInterceptors()